/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ShareInputs */

const en_share = /** @type {(inputs: ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share.`)
};

const es_share = /** @type {(inputs: ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparte.`)
};

const fr_share = /** @type {(inputs: ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partagez.`)
};

const de_share = /** @type {(inputs: ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilen.`)
};

const ja_share = /** @type {(inputs: ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`共有。`)
};

const zh_share = /** @type {(inputs: ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分享。`)
};

const ar_share = /** @type {(inputs: ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`شارك.`)
};

const id_share = /** @type {(inputs: ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bagikan.`)
};

const it_share = /** @type {(inputs: ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Condividi.`)
};

const ru_share = /** @type {(inputs: ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Делись.`)
};

const pt_share = /** @type {(inputs: ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compartilhe.`)
};

const ko_share = /** @type {(inputs: ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`공유.`)
};

/**
* | output |
* | --- |
* | "Share." |
*
* @param {ShareInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const share = /** @type {((inputs?: ShareInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ShareInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_share(inputs)
	if (locale === "es") return es_share(inputs)
	if (locale === "fr") return fr_share(inputs)
	if (locale === "de") return de_share(inputs)
	if (locale === "ja") return ja_share(inputs)
	if (locale === "zh") return zh_share(inputs)
	if (locale === "ar") return ar_share(inputs)
	if (locale === "id") return id_share(inputs)
	if (locale === "it") return it_share(inputs)
	if (locale === "ru") return ru_share(inputs)
	if (locale === "pt") return pt_share(inputs)
	return ko_share(inputs)
});